import { BaseService } from './baseService';

class CustomFieldsService extends BaseService<
	CustomField,
	'customFieldID',
	'customFields'
> {
	constructor() {
		super('customFieldID', 'customField', 'customFields');
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new CustomFieldsService();
